import React from "react";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex dark:bg-gray-900 transition-colors duration-200">
      {/* Your sidebar navigation goes here */}
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default Layout;
